define('../app/fukit/view/block/segment.container.view',['require','exports','module','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _     = require('underscore'),
      UIKit = require('uikit/uikit');

  var SegmentContainerView = UIKit.ComponentsContainerView.extend({
    className: 'ui segment',

    options: {
      attached: false,
      fitted: false,
      padded: false,
      basic: false,
      color: '',
      horizontal: false,
    },

    triggers: {
      click: {
        stopPropegation: false,
        preventDefault: false,
        event: 'press',
      },
    },

    updateAttributes: function() {
      var attached = this.getOption('attached');

      this.addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
      this.addClass(this.getOption('color'), this.getBoolOption('color'));
      this.addClass('fitted', this.getBoolOption('fitted'));
      this.addClass('basic', this.getBoolOption('basic'));
      this.addClass('horizontal', this.getBoolOption('horizontal'));
      this.addClass('padded', this.getBoolOption('padded'));
    },
  });

  module.exports = SegmentContainerView;
});

